import { render, staticRenderFns } from "./company-plan-usage.vue?vue&type=template&id=11722a16"
import script from "./company-plan-usage.vue?vue&type=script&lang=js"
export * from "./company-plan-usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports